import { FASTElement as l, attr as o } from "@microsoft/fast-element";
import { feedbackStyles as d } from "./feedback.styles.js";
import { feedbackTemplate as b } from "./feedback.template.js";
import { NumberStringConverter as k } from "../common/converters/number-string-converter.js";
var u = Object.defineProperty, f = (s, n, c, v) => {
  for (var e = void 0, t = s.length - 1, r; t >= 0; t--)
    (r = s[t]) && (e = r(n, c, e) || e);
  return e && u(n, c, e), e;
};
const i = class i extends l {
  constructor() {
    super(...arguments), this.feedbackValue = -1;
  }
  connectedCallback() {
    super.connectedCallback(), this.updateFeedback();
  }
  feedbackValueChanged() {
    this.$fastController.isConnected && this.updateFeedback();
  }
  updateFeedback() {
    switch (this.feedbackValue) {
      case 1:
        this.setPositiveFeedback();
        break;
      case 0:
        this.setNegativeFeedback();
        break;
      case -1:
        this.setNoFeedback();
        break;
    }
  }
  handleFeedbackPositiveClick() {
    this.feedbackValue = 1, this.$emit("feedback", !0, { cancelable: !1 });
  }
  handleFeedbackNegativeClick() {
    this.feedbackValue = 0, this.$emit("feedback", !1, { cancelable: !1 });
  }
  setNoFeedback() {
    this._positiveIconElement.setAttribute("variant", "outline"), this._negativeIconElement.setAttribute("variant", "outline");
  }
  setPositiveFeedback() {
    this._positiveIconElement.setAttribute("variant", "solid"), this._negativeIconElement.setAttribute("variant", "outline");
  }
  setNegativeFeedback() {
    this._positiveIconElement.setAttribute("variant", "outline"), this._negativeIconElement.setAttribute("variant", "solid");
  }
};
i.definition = {
  name: "feedback",
  template: b,
  styles: () => d
};
let a = i;
f([
  o({ converter: k })
], a.prototype, "feedbackValue");
export {
  a as Feedback
};
